export const THEME_COLOR = [
  '#fff', // 经典
  '#fff', // 典雅白
  '#2D2C2A', // 黑金
  '#E1F5E9', // 绿色
  '#DBF0FF', // 蓝色
  '#FFE0E5', // 粉红色
  '#2D2C2A' // 顶级婚礼
]
